import { useSearchParams } from 'react-router-dom';

import PortalInboxPage from './PortalInboxPage';
import RecruitmentInboxPage from './RecruitmentInboxPage';

export default function PortalInboxEntryPage() {
  const [searchParams] = useSearchParams();
  const department = String(searchParams.get('department') || 'staffing').trim().toLowerCase();

  if (department === 'recruitment') {
    return <RecruitmentInboxPage />;
  }

  return <PortalInboxPage />;
}
